module.exports = __webpack_public_path__ + "img/production.01b1b57f.svg";